module.exports = __webpack_public_path__ + "static/media/project client.ee71efc0.svg";